import { getApolloInstance } from "apollo/client"
import { GetServerSideProps } from "next"
import { PalletCompanies } from "page-components/companies"
import JobsLayout from "page-components/pallet/JobsLayout"
import NavbarLayout from "page-components/pallet/NavbarLayout"
import { PALLET_HEAD_QUERY } from "page-components/pallet/NavbarLayout/PalletHead/queries"
import { ReactElement } from "react"
import { getPalletContext, PalletContext } from "utils/router"
import { PalletHeadQuery } from "__generated__/PalletHeadQuery"

export const getServerSideProps: GetServerSideProps = async context => {
    const apolloClient = getApolloInstance({ request: context.req })
    let palletContext = await getPalletContext(context.req)
    const slug = palletContext.pallet
    const { data, error } = await apolloClient.query<PalletHeadQuery>({
        query: PALLET_HEAD_QUERY,
        variables: { slug: slug ?? "" },
    })

    if (error || !data.applylist) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            palletContext: palletContext,
            initialApolloState: apolloClient.cache.extract(),
        },
    }
}

const ListCompaniesPage = () => <PalletCompanies />

ListCompaniesPage.getLayout = (
    page: ReactElement,
    palletContext: PalletContext
) => {
    return (
        <NavbarLayout palletContext={palletContext}>
            <JobsLayout>{page}</JobsLayout>
        </NavbarLayout>
    )
}

export default ListCompaniesPage
